// extracted by mini-css-extract-plugin
module.exports = {"container":"_7122390","message":"_ec7b05c","buttons":"_8d2365e"};